import { observer } from 'mobx-react-lite';
import React from 'react';
import { colors } from '../../../colorVars';
import { setKillTrading } from '../../../stores/websocketStore/utils/outgoingMessages/killtrading/setKillTrading';
import { useWebsocketStore } from '../../../stores/websocketStore/websocketProvider';
import { ConnectBrokerageButton } from '../../atomic/buttons/connectBrokerageButton/ConnectBrokerageButton';
import { DocsButton } from '../../atomic/buttons/docsButton/DocsButton';
import { LogoutButton } from '../../atomic/buttons/logoutButton/LogoutButton';
import { OpenFormButton } from '../../atomic/buttons/openFormButton/OpenFormButton';
import TextButton from '../../atomic/buttons/textButton/TextButton';
import { TradeHistoryButton } from '../../atomic/buttons/tradeHistoryButton/TradeHistoryButton';
import TULogo from '../../atomic/logo/TULogo';
import Settings from '../settings/Settings';
import { AccountBalances } from './accountBalances/AccountBalances';
import style from './NavBar.module.css';
import { NavClock } from './NavClock';
import { SymbolsLeft } from './symbolsLeft/SymbolsLeft';
import { ApiCallsLeft } from './apicalls/ApiCallsLeft';
import { AlertsLinkButton } from '../../atomic/buttons/alertsLinkButton/AlertsLinkButton';
import { ChartTradingButton } from '../../atomic/buttons/chartTradingButton/ChartTradingButton';

export const NavBar = observer(
  ({ userPreferences, showTpViews, setShowTpViews, setShowChartTrading }) => {
    const openTradeHistory = () => {
      const url =
        window.config && window.config.REACT_APP_REDIRECT
          ? window.config.REACT_APP_REDIRECT + 'ui'
          : 'http://localhost:3000/ui';
      const tradeHistory = url + '/tradeHistory';
      window.open(tradeHistory, '_blank');
    };

    const openAlerts = () => {
      const url =
        window.config && window.config.REACT_APP_REDIRECT
          ? window.config.REACT_APP_REDIRECT + 'ui'
          : 'http://localhost:3000/ui';
      const alerts = url + '/alerts';
      window.open(alerts, '_blank');
    };

    const openDocs = () => {
      window.open('https://gargleblaster.github.io/tudocs/intro', '_blank');
    };

    const { killTradingStore, applicationTypeStore, userAuthStore } = useWebsocketStore();
    const applicationType = applicationTypeStore.applicationType ?? null;

    const tradingKilled = killTradingStore.tradingKilled;

    const handleLogout = async () => {
      // Logout from JWT auth (calls backend /api/auth/logout and clears localStorage)
      await userAuthStore.logout();

      // Redirect to frontend login page
      window.location.href = '/ui/login';
    };

    return (
      <header className={style.header}>
        <div className={style.logo}>
          <TULogo width={180} height={70} />
        </div>
        <div className={style.clockContainer}>
          <div className={style.flexColumn}>
            <NavClock />
            <SymbolsLeft />
            <ApiCallsLeft />
          </div>
          <TextButton
            margin="0 0 0 80px"
            clickHandler={() => setKillTrading(!tradingKilled)}
            width="120px"
            fontSize="medium"
            backgroundColor={tradingKilled ? colors.green : colors.red}
            color={colors.lightGrey}
          >
            {tradingKilled ? 'ALLOW TRADING' : 'KILL TRADING'}
          </TextButton>
        </div>
        <div className={style.buttonArray}>
          <ChartTradingButton
            size={30}
            title="Chart Trading"
            setShowChartTrading={setShowChartTrading}
          />
          {applicationType === 'TRADE_UNAFRAID_TESTING' ||
          applicationType === 'TRADE_UNAFRAID' ? (
            <AlertsLinkButton
              color={colors.lightGrey}
              size={30}
              title="Open Alerts"
              clickHandler={openAlerts}
            />
          ) : null}
          <AccountBalances />
          <Settings userPreferences={userPreferences} />
          <TradeHistoryButton
            clickHandler={openTradeHistory}
            color={colors.lightGrey}
            size={30}
          />
          <OpenFormButton
            size={30}
            color={colors.lightGrey}
            title={
              showTpViews ? 'Close Trade Plan Form' : 'Open Trade Plan Form'
            }
            clickHandler={() => setShowTpViews((prev) => !prev)}
          />
          <ConnectBrokerageButton
            color={colors.lightGrey}
            size={30}
            title="Login to your Tradier account"
            clickHandler={() => {
              const token = localStorage.getItem('jwt_token');
              if (!token) {
                alert('Please log in first before connecting your Tradier account.');
                return;
              }
              const baseUrl = window.config && window.config.REACT_APP_REDIRECT
                ? window.config.REACT_APP_REDIRECT
                : 'http://localhost:8080/';
              window.open(baseUrl + 'loginApp?token=' + encodeURIComponent(token), '_blank');
            }}
          />
          <DocsButton
            clickHandler={openDocs}
            size={32}
            color={colors.lightGrey}
          />
          <LogoutButton
            color={colors.red}
            size={30}
            clickHandler={handleLogout}
            title="Logout of Trade Unafraid"
          />
        </div>
        {/* <ApiCallsWarningModal
          open={warningModalOpen}
          handleClose={handleClose}
        /> */}
      </header>
    );
  }
);
